import Vue from "vue";
import VueRouter from 'vue-router';
import Dashboard from './components/Dashboard';
import Sessions from './components/Session';
import Control from './components/Control';
import Fine from './components/Fine';
import If from './components/If';
import Mercy from './components/Mercy';
import Log from './components/Log';
import Repository from './components/Repository';
import Parameter from './components/Parameter';
import Administration from './components/Administration';
import Monitoring from "./components/Monitoring";
import Device from './components/Device';
import Submission from './components/Submission';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            alias: ['/dashboard', '/home'],
            name: 'dashboard',
            component: Dashboard
        },
        {
            path: '/sessions',
            name: 'sessions',
            component: Sessions
        },
        {
            path: '/controls',
            params: '',
            name: 'controls',
            component: Control
        },
        {
            path: '/fines',
            name: 'fines',
            component: Fine
        },
        {
            path: '/ifs',
            name: 'ifs',
            component: If
        },
        {
            path: '/mercies',
            name: 'mercies',
            component: Mercy
        },
        {
            path: '/logs',
            name: 'logs',
            component: Log
        },
        {
            path: '/repositories',
            name: 'repositories',
            component: Repository
        },
        {
            path: '/parameters',
            name: 'parameters',
            component: Parameter
        },
        {
            path: '/administration',
            name: 'administration',
            component: Administration
        },
        {
            path: '/monitoring',
            name: 'monitoring',
            component: Monitoring
        },
        {
            path: '/devices',
            name: 'devices',
            component: Device
        },
        {
            path: '/manual-submission',
            name: 'submission',
            component: Submission
        },
    ]
});

export default router;



// WEBPACK FOOTER //
// ./resources/js/router.js